import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { useServerFn } from "@/lib/use-server-fn";
import { CrudManager } from "@/components/admin/CrudManager";
import { adminList } from "@/lib/admin.functions";
import { adminListQuery } from "@/lib/admin-queries";

export const Route = createFileRoute("/admin/galerias")({ component: Page });

function Page() {
  const callList = useServerFn(adminList);
  const { data: galleries } = useQuery({
    ...adminListQuery("galleries"),
    queryFn: () => callList({ data: { table: "galleries" as never } }),
  });

  const galleryOptions = (galleries ?? []).map((g: any) => ({
    label: g["name"] ?? g["slug"],
    value: g["id"],
  }));

  return (
    <div className="space-y-12">
      <CrudManager
        table="galleries"
        label="Galerias"
        slugSource="name"
        fields={[
          { name: "name", label: "Nome", type: "text", required: true },
          { name: "slug", label: "Slug", type: "slug", required: true },
          { name: "description", label: "Descrição", type: "textarea" },
          { name: "location", label: "Local", type: "text" },
          { name: "date", label: "Data", type: "date" },
          { name: "cover_url", label: "Capa", type: "image" },
          { name: "sort_order", label: "Ordem", type: "number" },
          {
            name: "status",
            label: "Status",
            type: "select",
            options: [
              { label: "Rascunho", value: "draft" },
              { label: "Publicado", value: "published" },
              { label: "Oculto", value: "hidden" },
            ],
          },
        ]}
        columns={[
          { key: "name", label: "Nome" },
          { key: "location", label: "Local" },
          { key: "status", label: "Status" },
        ]}
      />

      <CrudManager
        table="gallery_images"
        label="Fotos das galerias"
        fields={[
          {
            name: "gallery_id",
            label: "Galeria",
            type: "select",
            required: true,
            options: galleryOptions,
          },
          { name: "image_url", label: "Imagem", type: "image", required: true },
          { name: "caption", label: "Legenda", type: "text" },
          { name: "alt_text", label: "Texto alternativo", type: "text" },
          { name: "sort_order", label: "Ordem", type: "number" },
        ]}
        columns={[
          {
            key: "gallery_id",
            label: "Galeria",
            render: (r) =>
              galleryOptions.find((o) => o.value === r["gallery_id"])?.label ?? "—",
          },
          { key: "caption", label: "Legenda" },
          { key: "sort_order", label: "Ordem" },
        ]}
      />
    </div>
  );
}
